export default __webpack_public_path__ + "static/media/daryn.c5fcfe24.svg";